import React, {useState,useEffect} from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import PlaySvg from '../../svg/Play';
import { fetchSchoolMissions } from '../../services2/pschoolMissions.service';
import { studentFetchStudentMissions } from '../../services2/pstudentMissions.service';
function Component(props) {
  const {  } = useParams();
  const navigate = useNavigate();
  const [data,setdata] = useState(null)
  const [isLoading,setisLoading]=useState(false)


  const fetchData=async(force=false)=>{
    if(isLoading&&!force)return
    setisLoading(true)
    let result = await fetchSchoolMissions(props.token.token,{isPublic:true},{limit:99});
    if(result.result){
        setdata(result.result)
    }else{
        alert('Fetch data error')
    }
    setisLoading(false)
  }
  const [studentMissions,setStudentMissions]=useState([])
  const fetchCompletedStudentMissions=async()=>{
      let result = await studentFetchStudentMissions(props.token.token, { status:'已完成'});
      if (result.result) {
          setStudentMissions(result.result || [])
      } else {
          alert('Fetch data error')
      }
  }

  useEffect(()=>{
    fetchData();
    fetchCompletedStudentMissions()
  },[])

  const isMobile=window.innerWidth<1024


  return (
    <div className='flex-[1] flex flex-col h-full p-[16px] gap-[16px]' style={{overflowY:"auto"}}>


        {/*missions*/}
        <div className='text-[#43528A]' style={{fontSize:isMobile?'14px':'18px'}}>
          最新閲讀任務
        </div>

        <div className='flex flex-row gap-[16px] w-full flex-wrap' style={{}}>
          {data?.map((item,index)=>
            <div key={item?._id||index} className='rounded-[20px] bg-[white] flex flex-col cursor-pointer hover:opacity-[.8]' style={{overflow:'hidden',height:isMobile?300/3*2:300,width:isMobile?550/3*2:550, 
              opacity: item.missionId==='698a92675450edeae46744a8' && !studentMissions.find(i=>i.missionId==='698457c0dd32bf81834ded8f')?0.5:
              item.missionId==='69c957ed83120ab359e7c602' && !studentMissions.find(i=>i.missionId==='698a92675450edeae46744a8')?0.5:
              item.missionId==='69c9581483120ab359e7c603' && !studentMissions.find(i=>i.missionId==='69c957ed83120ab359e7c602')?0.5:1
            }} onClick={()=>{
              //task 1 698457c0dd32bf81834ded8f
              //task 2 698a92675450edeae46744a8
              //task 3 69c957ed83120ab359e7c602
              //task 4 69c9581483120ab359e7c603
              // must complete previous task to unlock next task
              if(item.missionId==='698457c0dd32bf81834ded8f'){
                //first task, no need to check
              }else if(item.missionId==='698a92675450edeae46744a8'){
                //second task, need to check if first task is completed
                if(!studentMissions.find(i=>i.missionId==='698457c0dd32bf81834ded8f')){
                  alert('請先完成第一個任務')
                  return
                }
              }else if(item.missionId==='69c957ed83120ab359e7c602'){
                //third task, need to check if second task is completed
                if(!studentMissions.find(i=>i.missionId==='698a92675450edeae46744a8')){
                  alert('請先完成第二個任務')
                  return
                }
              }else if(item.missionId==='69c9581483120ab359e7c603'){
                //fourth task, need to check if third task is completed
                if(!studentMissions.find(i=>i.missionId==='69c957ed83120ab359e7c602')){
                  alert('請先完成第三個任務')
                  return
                }
              }

              navigate(`/platform2/missions/${item?.missionId}`)
            }}>
              {item?.mission?.photo?<img src={item?.mission?.photo} className='w-full rounded-[20px]' style={{height:isMobile?205/3*2:205,objectFit:'cover'}}/>:<div className='w-full h-[205px] bg-[#999] rounded-[20px]'/>}
              <div className='flex flex-row w-full'>
                <div className='flex flex-col flex-1'>
                  <div className='flex flex-row w-full items-end text-[#43528A] flex-wrap' style={{paddingLeft:isMobile?8:16,paddingRight:isMobile?8:16,gap:isMobile?4:16,paddingTop:isMobile?2:8}}>
                    <div className='text-[#43528A] font-[700]' style={{fontSize:isMobile?14:24}}>{item?.mission?.name}</div>
                    <div className='text-[#43528A]' style={{fontSize:isMobile?12:18}}>時間: {item?.mission?.time} 分鐘</div>
                  </div>
                  <div className='mt-[2px] flex flex-row w-full items-end text-[#43528A] flex-wrap'  style={{paddingLeft:isMobile?8:16,paddingRight:isMobile?4:16,gap:isMobile?8:16}}>
                    <div className='' style={{fontSize:isMobile?12:18}}>{item?.mission?.mission||''}</div>
                    {/* <div className='' style={{fontSize:isMobile?12:18}}>{item?.mission?.category||''}</div> */}
                  </div>
                </div>
                <div className='h-full flex flex-row items-center' style={{padding:isMobile?4:16}}>
                  <PlaySvg width={isMobile?28:44}/>
                </div>
              </div>
            </div>
          )}
        </div>
        {/*end of missions*/}

       
        {isLoading&&<LoadingPage/>}
    </div>
  );
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)
  